
$(document).ready(function(){

    if (window.matchMedia("(max-width: 1199px)").matches) {  

        var headerHeight = $('.logoNav').outerHeight();

        $('.js-toggleMenu').on('click',function(e){
            e.preventDefault();

            $(this).toggleClass('is-open');
            $('body').toggleClass('nav-expanded');
        });


        $('.anchorNav a').on('click',function(event){
            $('body').toggleClass('nav-expanded');
        });

        //Sottomenu
        $('.has-submenu>a').on('click',function(event){
            event.preventDefault();
            $(this).siblings('.submenu').slideToggle('slow');
            $(this).parent().toggleClass('is-selected');
            if($(this).attr('aria-expanded') == 'true'){
                $(this).attr('aria-expanded','false').parents().siblings('.has-submenu').children('a').attr('aria-expanded','false');
            }
      
            else if($(this).attr('aria-expanded') == 'false'){
                $(this).attr('aria-expanded','true').parents().siblings('.has-submenu').children('a').attr('aria-expanded','false');
            }
        });

        $('.submenu .title').on('click',function(event){
            event.preventDefault();
            $(this).siblings('ul').slideToggle('slow');
            $(this).toggleClass('closeMenu');
        });

    }


    // Sottomenu desktop
    if (window.matchMedia("(min-width: 1200px)").matches){

        $('.has-submenu > a').on('click', function(event){
            event.preventDefault();

            if($(this).attr('aria-expanded') == 'true'){    
                $(this).attr('aria-expanded','false').parents().siblings('.has-submenu').children('a').attr('aria-expanded','false');
            }
      
            else if($(this).attr('aria-expanded') == 'false'){
                $(this).attr('aria-expanded','true').parents().siblings('.has-submenu').children('a').attr('aria-expanded','false');
            }
             
            var selectedItem = $(this).parent('.has-submenu');

            if(!$(selectedItem).hasClass('is-selected')){
                $('.has-submenu').removeClass('is-selected').children('.submenu').removeClass('is-open');
                selectedItem.addClass('is-selected').children('.submenu').addClass('is-open');
            }
            
            else{
                selectedItem.removeClass('is-selected').children('.submenu').removeClass('is-open');
            }
        });
       
  
      $(document).click(function (e) {
        //check if the clicked area is dropDown or not
          if ($('.has-submenu').has(e.target).length === 0) {
                $('.has-submenu').removeClass('is-selected').children('.submenu').removeClass('is-open');
            }
          
          if ($('.js-dropdown,.js-dropdown > ul').has(e.target).length === 0) {
                $('.js-dropdown > ul').hide();
            }
           
        })
    }

    // Larghezza progress bar progetti landing 
    $("div[data-progress]").each(function(){
        $(this).css({
            width: $(this).attr('data-progress')
        });
    });

    // FAQ
  /*   $('.faq div').each(function() { // per evitare salto animazione
        $height = $(this).height();
        $(this).css('height', $height);
        $(this).hide();
       }); */
   
    $('.faq h3').on('click',function(event){
        event.preventDefault();
        $(this).next('div').slideToggle('200');
        $(this).toggleClass('is-selected');
    });

 // TABS-ACCORDION

 var $titleTabs = $('.tabs-accordion .js-header');


 if (window.matchMedia("(max-width: 767px)").matches){


     $('.tabs-accordion .js-content').hide();
     $(".tabs-accordion .accordion__content[aria-labelledby='tab0']").show();


     $titleTabs.click(function () {
         $(this).next().slideToggle();
         $(this).toggleClass('active');
         $(this).parent().siblings().children().next().slideUp();
         $(this).parent().siblings().children().removeClass('active');
         return false;
     });


     $titleTabs.keydown(function(e){ // usare keydown e non keyup perché così si può sovrascrivere il comportamento di default della space-bar che se selezionata fa scrollare la pagina
         var keyCode = e.keyCode || e.which;

         if(keyCode == 13 || keyCode == 32){    // all'invio o alla space-bar
             $(this).next(copy).slideToggle();
             $(this).toggleClass('active');
             $(this).parent().siblings().children().next().slideUp();
             $(this).parent().siblings().children().removeClass('active');


             return false;
         }
     });
 }


 else if (window.matchMedia("(min-width: 768px)").matches){

     // Hide all but first tab content on larger viewports
     $('.tabs-accordion .js-content:not(:first)').css('display', 'none');

     // Activate first tab
     $(".tabs-accordion .accordion__header[aria-controls='panel0']");


     //var contentHeight = $('.accordion__item:first-child .accordion__header.active').next('.js-content').children('.blockTxtImg').outerHeight();  

     //var contentHeight = $('.accordion__content').outerHeight();                


     //$('.tabs-accordion').height(contentHeight); //  altezza header + padding testo

     $titleTabs.click(function () {                                      
         $(this).next().css('display', 'flex');
         $(this).parent().siblings().children().next().css('display', 'none');
         $(this).addClass('active');
         $(this).parent().siblings().children().removeClass('active');

         //var newContentHeight = $(this).next('.js-content').outerHeight();          
         //$('.tabs-accordion').height(newContentHeight ); //  altezza header

         return false;
     });


     $titleTabs.focus(function(e){

         $(this).next().css('display', 'flex');
         $(this).parent().siblings().children().next().css('display', 'none');
         $(this).addClass('active');
         $(this).parent().siblings().children().removeClass('active');
        
         /* var newContentHeight = $('.js-header.active').next('.js-content').children('.blockTxtImg').outerHeight();          
     $('.tabs-accordion').height(newContentHeight + 64);*/

         $(this).parent('.js-item').attr('aria-expanded','true').siblings().attr('aria-expanded','false');

     });

 } 


  //Accordion

  $('section:not(:has(.filters)) .accordion .js-content').hide();    
  $('section:not(:has(.filters)) .accordion__item .js-header').attr('aria-expanded','false');

  $('section:not(:has(.filters)) .accordion .js-header').click(function () {
      $(this).next().slideToggle();
      $(this).toggleClass('active');

      $(this).parent().siblings().children().removeClass('active');
      


      // toggle attributi
      if($(this).attr('aria-expanded') == 'true'){
          $(this).attr('aria-expanded','false');
      }

      else if($(this).attr('aria-expanded') == 'false'){
          $(this).attr('aria-expanded','true').siblings().attr('aria-expanded','false');
      }

      return false;

  });

  var $item = $('section:not(:has(.filters)) .accordion .js-item'); // per la tastiera ridefinisco il selettore perché è l'item ad essere focusable a differenza del clic del mouse cha va sull'header

  $item.keydown(function(e){ // usare keydown e non keyup perché così si può sovrascrivere il comportamento di default della space-bar che se selezionata fa scrollare la pagina

      var keyCode = e.keyCode || e.which;
      if(keyCode == 13 || keyCode == 32){    // all'invio o alla space-bar
          $(this).children(title).next().slideToggle();
          $(this).siblings().children().next().slideUp();
          $(this).children(title).toggleClass('active');

          $(this).siblings().children().removeClass('active');


          if($(this).children(title).attr('aria-expanded') == 'true'){
              $(this).children(title).attr('aria-expanded','false');
          }

          else if($(this).children(title).attr('aria-expanded') == 'false'){
              $(this).children(title).attr('aria-expanded','true').siblings().attr('aria-expanded','false');
          }

          return false;
      }
  });

  
    $('.filters .accordion .js-content').hide();    
    $('.filters .accordion__item .js-header').attr('aria-expanded','false');
  
  
    $('.filters .accordion .js-header').click(function () {
        $(this).next().slideToggle();
        $(this).toggleClass('active');
  
        $(this).parent().siblings().children().removeClass('active');
        
  
  
        // toggle attributi
        if($(this).attr('aria-expanded') == 'true'){
            $(this).attr('aria-expanded','false');
        }
  
        else if($(this).attr('aria-expanded') == 'false'){
            $(this).attr('aria-expanded','true').siblings().attr('aria-expanded','false');
        }
  
        return false;
  
    });
  
    var $item = $('.filters .accordion .js-item'); // per la tastiera ridefinisco il selettore perché è l'item ad essere focusable a differenza del clic del mouse cha va sull'header
  
    $item.keydown(function(e){ // usare keydown e non keyup perché così si può sovrascrivere il comportamento di default della space-bar che se selezionata fa scrollare la pagina
  
        var keyCode = e.keyCode || e.which;
        if(keyCode == 13 || keyCode == 32){    // all'invio o alla space-bar
            $(this).children(title).next().slideToggle();
            $(this).siblings().children().next().slideUp();
            $(this).children(title).toggleClass('active');
  
            $(this).siblings().children().removeClass('active');
  
  
            if($(this).children(title).attr('aria-expanded') == 'true'){
                $(this).children(title).attr('aria-expanded','false');
            }
  
            else if($(this).children(title).attr('aria-expanded') == 'false'){
                $(this).children(title).attr('aria-expanded','true').siblings().attr('aria-expanded','false');
            }
  
            return false;
        }
    });
  


  // Progetti
  var countProjects = document.querySelectorAll('.gridCols.projects article').length;
if(countProjects == 1){
    $(this).addClass('onlyOne');
}
 // Swiper slider
 const swiper = new Swiper('.swiper', {
    slidesPerView: 1.5,
    spaceBetween: 20,
    centeredSlides: true,
    speed: 200,
    slideRole: null,

    breakpoints: {
        // when window width is >= 768px
        481: {
            slidesPerView: 1,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            }

        },
    }
});

 // Swiper slider cards
 //if (window.matchMedia("(max-width: 991px)").matches) {  
 const swiperCards = new Swiper('.swiper-cards', {
    slidesPerView: 1.5,
    spaceBetween: 20,
    centeredSlides: true,
    speed: 200,
    slideRole: null,
    pagination: {
        el: '.swiper-pagination',
        clickable: true,
    },

    breakpoints: {
        // when window width is >= 1200px
        1200: {
            slidesPerView: 4,
            centeredSlides: false
        },
        992: {
            slidesPerView: 3,
            centeredSlides: false
        },
        768: {
            slidesPerView: 2,
            centeredSlides: false
        },
    }
});
 //}


if ($('.mastheadVideo').length > 0 && $('#mastVideo').length > 0 && $('#mastVideoPlay').length > 0) {
    const mastVideo = document.getElementById('mastVideo');
    const mastVideoPlay = document.getElementById('mastVideoPlay');
    const mastVideoSection = document.querySelector('.masthead');
    mastVideoPlay.addEventListener("click", () => {
        mastVideo.play();
        mastVideoSection.classList.add('is-playing');
    });
    mastVideo.addEventListener('ended', () => {
        mastVideo.load();
        mastVideoSection.classList.remove('is-playing');
    }, false);
  }
});

// Ricerca + suggerimenti

if (window.matchMedia("(min-width: 768px)").matches) {  
    $(".is-ajax-search input[type='search']").on('focusout', function(){
        $("div.is-ajax-search-result").hide();
    
    });
    
    $(".is-ajax-search input[type='search']").on('keyup', function(){
        $(".is-loader-image").show();
    
        var selected = $(this);
    
        if(selected.val().length >= 1){
            setTimeout(function() { 
                selected.next(".is-loader-image").hide();
                $("div.is-ajax-search-result").show();
            }
                       , 700);
        }
    
        else{
            selected.next(".is-loader-image").hide();
            setTimeout(function() { 
                $("div.is-ajax-search-result").hide();    
            }
                       , 700);
        }
    });
    }
